import { Divider } from 'antd';
import { useSelector } from 'react-redux';

import Editor from '../../../components/pageComponents/Editor';

const IntakeSummaryForms = () => {
  const { getUuid } = useSelector((state) => state?.appointmentState);

  return (
    <div>
      {getUuid?.appointment_details?.llm_intake_summary_forms && (
        <>
          <Divider />
          <div>
            <h1 className="flex justify-center text-xs text-gray-400 my-3">
              Forms Summary
            </h1>
            <div className="bg-white rounded-bl-xl rounded-br-xl">
              <Editor
                value={
                  getUuid?.appointment_details?.llm_intake_summary_forms.replaceAll(
                    '\n',
                    '<br>'
                  ) || ''
                }
                theme="snow"
                className={`ql-toolbar z-10 font-sans`}
                style={{ border: 'none', height: '100%' }}
                disabled={true}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default IntakeSummaryForms;
